import { Breadcrumb, Col, type BreadcrumbProps } from 'antd';
import { useEffect, useState, type FC, type ReactNode } from 'react';
import styles from "./BreadCrumbs.module.css"


interface BreadCrumbsProps {
  breadCrumbParent?: ReactNode;
  breadCrumbParent2?: ReactNode;
  breadCrumbParent3?: ReactNode;
  breadCrumbActive?: ReactNode;
}

const BreadCrumbs: FC<BreadCrumbsProps> = ({
  breadCrumbParent,
  breadCrumbParent2,
  breadCrumbParent3,
  breadCrumbActive,
}) => {
  const [items, setItems] = useState<BreadcrumbProps['items']>([]);

  useEffect(() => {
    const nextItems: BreadcrumbProps['items'] = [];

    if (breadCrumbParent) {
      nextItems.push({ key: 'parent', title: breadCrumbParent });
    }

    if (breadCrumbParent2) {
      nextItems.push({ key: 'parent-2', title: breadCrumbParent2 });
    }

    if (breadCrumbParent3) {
      nextItems.push({ key: 'parent-3', title: breadCrumbParent3 });
    }

    nextItems.push({ key: 'active', title: breadCrumbActive });

    setItems(nextItems);
  }, [breadCrumbActive, breadCrumbParent, breadCrumbParent2, breadCrumbParent3]);

  return (
    <Col>
      <Breadcrumb className={styles.wrapper} items={items} />
    </Col>
  );
};

export default BreadCrumbs;
